import { Box } from '@breathelife/mui';
import styled from '../../Styles/themed-styled-components';

export const GreyContainer = styled(Box)`
  background-color: ${(props) => props.theme.colors.grey[20]};
`;
